<template>
    <div class="pay">
        <Header ref="header" @backPage="orderDetail" :title="title"></Header>
        <div class="h88"></div>
        <div class="img">
            <img src="../../../assets/img/b2b/img_right@2x.png" alt="">
        </div>
        <div class="h3">支付成功</div>
        <!-- <div class="p">支付金额 <span>¥ {{ paymentAmount | numFilter }}</span></div>
        <div class="p">支付方式 <span v-text="source == 1 ? '账期支付' : '钱包支付'"></span></div> -->
        <div class="btn" @click="orderDetail">查看订单</div>
    </div>
</template>
<script>
import Header from '../../common/header'
export default {
    name: 'paySuccess',
    components: {
        Header
    },
    data () {
        return {
            title: '支付成功'
        }
    },
    methods: {
        orderDetail () {
            localStorage.setItem('orderNum', '1') // 修改为跳转到待发货页面
            this.$router.push({
                path: '/b2b/order/orderList' // 去订单列表
            })
        }
    },
    mounted () {
        this.id = this.$route.query.id ? this.$route.query.id : ''
    }
}
</script>
<style lang="scss" scoped>
    .pay{
        padding: 120px 128px;
        font-size: 28px;
        .img{
            width: 144px;
            height: 144px;
            margin: 0 auto;
        }
        .h3{
            font-size: 32px;
            margin-top: 36px;
            margin-bottom: 12px;
            text-align: center;
        }
        .p{
            padding-left: 120px;
            color: #8E8E93;
            margin-bottom: 4px;
            span{
                margin-left: 20px;
            }
        }
        .btn{
            width: 100%;
            margin-top: 100px;
            height: 96px;
            line-height: 96px;
            text-align: center;
            font-size: 36px;
            color: #FF7A45;
            border: 2px solid #FF7A45;
            border-radius: 96px;
        }
    }
</style>
